import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableInvoiceSearchPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableInvoiceSearchPage;
